import React from 'react';
import { connect } from 'react-redux';
import { MqttConsumer } from 'helpers/mqtt/MqttProvider';
import ScheduleCalendarComponent from './ScheduleCalendarComponent';
import { loadLocationData } from '../../actions/dashboard-actions'

import actions from './duck/actions'
import { scheduleCalendarOperations, } from './duck';
import { unregisteredUserOperations } from '../UnregisteredUser/duck';
import { userManagementOperations } from '../UserManagement/duck';
import { appOperations } from 'App/duck';

import timeUtil from './duck/timeUtil';
import draftLogic from './duck/draftLogic';

const mapStateToProps = ({
  locationReducer,
  appReducer,
  scheduleCalendarReducer,
  unregisteredUserReducer,
  setupReducer,
}) => {
  return {
    locationId: locationReducer.location_code,
    shifts: scheduleCalendarReducer.shifts.data,
    rangeStart: scheduleCalendarReducer.dateRange.start,
    rangeEnd: scheduleCalendarReducer.dateRange.end,
    startStr: scheduleCalendarReducer.dateRange.startStr,
    needReset: scheduleCalendarReducer.dateRange.needReset,
    shiftsLoading: scheduleCalendarReducer.shifts.loading,
    usersLoading: scheduleCalendarReducer.allUsers.loading,
    allUsers: scheduleCalendarReducer.allUsers.users,
    associates: appReducer.associates.users,
    managers: appReducer.managers.users,
    plans: appReducer.plans.data,
    locationData: locationReducer.location_data,
    unregisteredUsers: unregisteredUserReducer.unregisteredUsers.users,
    departments: appReducer.departments.data,
    skills: appReducer.skills.data,
    channels: appReducer.channels.data,
    isPublishing: scheduleCalendarReducer.shifts.publishing,
    showingToast: scheduleCalendarReducer.shifts.showingToast,
    toastMessage: scheduleCalendarReducer.shifts.toastMessage,
    isVTOConfigured: setupReducer.setup_actions?.meta?.current_location?.cfg_vto || false,
    // isVTOConfigured: false,
  };
};

const mapDispatchToProps = (dispatch) => {

  const loadLocationRolesDispatch = (locationId) => {
    dispatch(appOperations.fetchLocationRolesOperation(locationId));
  };

  const loadLocationSkillsDispatch =  (locationId) =>  {
    dispatch(scheduleCalendarOperations.getLocationUsableSkills(locationId));
  };

  const removeShiftFromReducer = (shiftId) => {
    dispatch(actions.deleteSingleShift({ scheduleId: shiftId }));
  };

  const loadSingleShiftDispatch = (shiftId) => {
    dispatch(scheduleCalendarOperations.fetchSingleShiftOperation(shiftId));
  }

  const loadSingleApplicantDispatch = (applicantId) => {
    dispatch(scheduleCalendarOperations.fetchSingleApplicantOperation(applicantId));
  }

  const loadChannelsToPostDispatch = (locationId) => {
    dispatch(userManagementOperations.getLocationChannels(locationId));
  }

  const removeShowingToastDispatch = () => {
    dispatch(scheduleCalendarOperations.removeShowingToastOperation());
  }

  const clearDateRangeResetFlagDispatch = () => {
    dispatch(scheduleCalendarOperations.clearResetFlagOperation());
  }

  const loadDepartments = (locationId) => {
    dispatch(userManagementOperations.getLocationInnerDepartments(locationId));
  };

  const loadUnregisteredUsersDispatch = (locationId) => {
    dispatch(unregisteredUserOperations.fetchUnregisteredUsersDispatch(locationId));
  };

  const loadLocationDataDispatch = () => {
    dispatch(loadLocationData());
  };

  const changeDateRangeSlice = (from, to) => {
    dispatch(scheduleCalendarOperations.changeDateRangeOperation(from, to));
  };

  const getShiftsInDateRange = (from, to, pageNum, perPageNum, includeNonPublicInventory) => {
    dispatch(scheduleCalendarOperations.fetchCompactShiftsInDateRange(from, to, pageNum, perPageNum, includeNonPublicInventory));
  };

  const getScheduleUsers = (locationId, pageNo, numPerPage) => {
    dispatch(scheduleCalendarOperations.fetchScheduleUsers(locationId, pageNo, numPerPage));
  };

  const linkUnregisteredUser = (unregistered_user_id, target_user_id, rangeStart, rangeEnd) => {
    dispatch(scheduleCalendarOperations.linkUnregisteredUser(unregistered_user_id, target_user_id, rangeStart, rangeEnd));
  };

  const notifyTeamOfPublishDispatch = (locationId, message, event, userIds) => {
    dispatch(scheduleCalendarOperations.notifyTeamOperation(locationId, message, event, userIds));
  };

  const loadSingleFreePostDispatch = (postId) => {
    dispatch(scheduleCalendarOperations.fetchSingleFreePostOperation(postId));
  }

  const publishDraftShiftsDispatch = (shiftsToPublish) => {
    const total = shiftsToPublish.length;

    const payload = { totalToPublish: total }
    dispatch(actions.changeStatusToPublishing(payload))

    shiftsToPublish.forEach(shift => {
      dispatch(scheduleCalendarOperations.publishDraftShiftOperation(shift.id, total));
    });
  };

  const deleteAllShiftsDispatch = (shifts, locationId, rangeStart, rangeEnd) => {
    shifts.forEach(element => {
      if (timeUtil.isShiftInRange(element, rangeStart, rangeEnd) == true) {
        dispatch(scheduleCalendarOperations.deleteShiftOperation(element.id, locationId));
      }
    });
  }

  const deleteAllDraftShiftsDispatch = (shifts, locationId, rangeStart, rangeEnd) => {
    if (typeof shifts != 'undefined' && shifts != null) {
      shifts.forEach(element => {
        if (draftLogic.isDraftShift(element) == true && timeUtil.isShiftInRange(element, rangeStart, rangeEnd) == true) {
          dispatch(scheduleCalendarOperations.deleteShiftOperation(element.id, locationId));
        }
      });
    }
  }

  const resetShifts = (loading) => {
    dispatch(actions.resetShifts(loading));
  };
  return {
    changeDateRangeSlice,
    getShiftsInDateRange,
    getScheduleUsers,
    linkUnregisteredUser,
    loadLocationDataDispatch,
    notifyTeamOfPublishDispatch,
    publishDraftShiftsDispatch,
    loadUnregisteredUsersDispatch,
    loadDepartments,
    deleteAllDraftShiftsDispatch,
    deleteAllShiftsDispatch,
    clearDateRangeResetFlagDispatch,
    removeShowingToastDispatch,
    loadChannelsToPostDispatch,
    loadSingleShiftDispatch,
    loadSingleApplicantDispatch,
    loadSingleFreePostDispatch,
    removeShiftFromReducer,
    resetShifts,
    loadLocationRolesDispatch,
    loadLocationSkillsDispatch,
  };
};

const ScheduleCalendarContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  return (
    <MqttConsumer>
      {(client) => {
        const { locationId,
          shifts,
          rangeStart,
          rangeEnd,
          startStr,
          needReset,
          allUsers,
          associates,
          managers,
          locationSettings,
          changeDateRangeSlice,
          getShiftsInDateRange,
          usersLoading,
          getScheduleUsers,
          linkUnregisteredUser,
          plans,
          locationData,
          loadLocationDataDispatch,
          notifyTeamOfPublishDispatch,
          loadUnregisteredUsersDispatch,
          unregisteredUsers,
          departments,
          loadDepartments,
          publishDraftShiftsDispatch,
          deleteAllDraftShiftsDispatch,
          deleteAllShiftsDispatch,
          clearDateRangeResetFlagDispatch,
          removeShowingToastDispatch,
          loadChannelsToPostDispatch,
          channels,
          skills,
          loadSingleShiftDispatch,
          loadSingleApplicantDispatch,
          loadSingleFreePostDispatch,
          isPublishing,
          removeShiftFromReducer,
          showingToast,
          toastMessage,
          loadLocationRolesDispatch,
          isVTOConfigured,
          loadLocationSkillsDispatch,
        } = props;

        return (
          <ScheduleCalendarComponent
            mqttClient={client}
            locationId={locationId}
            shifts={shifts}
            rangeStart={rangeStart}
            rangeEnd={rangeEnd}
            startStr={startStr}
            needReset={needReset}
            allUsers={allUsers}
            associates={associates}
            managers={managers}
            locationSettings={locationSettings}
            loading={usersLoading}
            changeDateRangeSlice={changeDateRangeSlice}
            getShiftsInDateRange={getShiftsInDateRange}
            getScheduleUsers={getScheduleUsers}
            linkUnregisteredUser={linkUnregisteredUser}
            plans={plans}
            locationData={locationData}
            loadLocationDataDispatch={loadLocationDataDispatch}
            notifyTeamOfPublishDispatch={notifyTeamOfPublishDispatch}
            loadUnregisteredUsersDispatch={loadUnregisteredUsersDispatch}
            unregisteredUsers={unregisteredUsers}
            departments={departments}
            loadDepartments={loadDepartments}
            publishDraftShiftsDispatch={publishDraftShiftsDispatch}
            deleteAllDraftShiftsDispatch={deleteAllDraftShiftsDispatch}
            deleteAllShiftsDispatch={deleteAllShiftsDispatch}
            clearDateRangeResetFlagDispatch={clearDateRangeResetFlagDispatch}
            removeShowingToastDispatch={removeShowingToastDispatch}
            loadChannelsToPostDispatch={loadChannelsToPostDispatch}
            channels={channels}
            skills={skills}
            loadSingleShiftDispatch={loadSingleShiftDispatch}
            loadSingleApplicantDispatch={loadSingleApplicantDispatch}
            loadSingleFreePostDispatch={loadSingleFreePostDispatch}
            isPublishing={isPublishing}
            removeShiftFromReducer={removeShiftFromReducer}
            showingToast={showingToast}
            toastMessage={toastMessage}
            loadLocationRolesDispatch={loadLocationRolesDispatch}
            isVTOConfigured={isVTOConfigured}
            loadLocationSkillsDispatch={loadLocationSkillsDispatch}
          />
        );
      }}
    </MqttConsumer>
  );
});

export default ScheduleCalendarContainer;
